export enum ELanguageCode {
  ENGLISH = "en",
  BANGLA = "bn",
  URDU = "urdu",
}
